import React from 'react'

const HeadingComponent = ({ variant = "main", children }) => {
  const headingStyles = {
    main: "text-center font-semibold text-[20px]",
    sub: "text-center font-semibold text-[20px]",
    md: "text-center font-semibold text-[16px]",
    sm: "text-center font-semibold text-[14px]",
    cfo: "text-center font-semibold text-[20px] text-[#0070C0]",
    cfoSub: "font-md text-[18px]"
  }

  const renderHeading = () => {
    switch(variant) {
      case "main":
        return <h1 className={headingStyles.main}>{children}</h1>
      case "sub":
        return <h6 className={headingStyles.sub}>{children}</h6>
      case "cfo":
        return <h3 className={headingStyles.cfo}>{children}</h3>
      case "cfoSub":
        return <h3 className={headingStyles.cfoSub}>{children}</h3>
      case "md":
        return <h5 className={headingStyles.md}>{children}</h5>
      case "sm":
        return <h6 className={headingStyles.sm}>{children}</h6>
      default:
        return <h1 className={headingStyles.main}>{children}</h1>
    }
  }

  return renderHeading()
}

export default HeadingComponent